import {createSinglePathSVG} from './TEMPLATE'

/**
 * Insert-footnote toolbar glyph ("A²"), exported directly from Figma
 * (node 167:324, file pxYtWNgjV2VOLMGYr0ujlL) - filled, not stroked, unlike
 * every other toolbar icon, per that node's own Figma documentation. Not a
 * superscript control despite the inherited Untitled UI layer name.
 */
export const FootnoteA_Filled = createSinglePathSVG({
  path: 'M4.12795 17L5.36241 13.5256H9.90677L11.1412 17H12.7872L8.44085 5.43563H6.84634L2.5 17H4.12795ZM7.66159 7.18076L9.48628 12.3321H5.7829L7.61659 7.18076H7.66159ZM14.2608 4.99234V4.90101C14.2608 4.49669 14.5617 4.1484 15.0568 4.1484C15.512 4.1484 15.8515 4.46016 15.8515 4.85473C15.8515 5.29558 15.503 5.64509 15.1828 5.94833L12.8836 8.17937V9.08907H17.5V7.92241H15.0272V7.86761L16.2784 6.60108C16.812 6.06768 17.3933 5.57203 17.3933 4.71712C17.3933 3.74287 16.4919 3 15.0954 3C13.5137 3 12.7872 3.97425 12.7872 4.91928V4.99234H14.2608Z',
  viewBox: '0 0 20 20',
})
